const JoinScreen = ({ playerName, setPlayerName, roomCode, setRoomCode, onSubmit, onBack, error }) => (
  <div className="card">
    <div className="logo-tag">Join Room</div>
    <h1>Enter the <span className="accent">Arena</span></h1>

    {error && <div className="error-box">⚠️ {error}</div>}

    <div className="input-group">
      <label>Your Name</label>
      <input
        value={playerName}
        onChange={e => setPlayerName(e.target.value)}
        placeholder="Enter your name"
        autoFocus
      />
    </div>

    <div className="input-group">
      <label>Room Code</label>
      <input
        value={roomCode}
        onChange={e => setRoomCode(e.target.value.toUpperCase())}
        placeholder="e.g. AB12C"
        maxLength={6}
        onKeyDown={e => e.key === "Enter" && onSubmit()}
      />
    </div>

    <button className="btn btn-primary" onClick={onSubmit}>
      Join Game →
    </button>
    <button className="btn btn-ghost" onClick={onBack}>
      ← Back
    </button>
  </div>
);

export default JoinScreen;